import React from 'react';
import { Box, LinearProgress, Typography } from '@material-ui/core';

interface ProgressIndicatorProps {
    bottomLeftText?: string;
    bottomRightText?: string;
    progress: number;
}

const ProgressIndicator = ({ bottomLeftText, bottomRightText, progress }: ProgressIndicatorProps) => {

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <LinearProgress variant="determinate" value={progress} />
            <Box mb={1} />
            {(bottomLeftText || bottomRightText) && (
            <Box display="flex" justifyContent="space-between">
                <Typography>{bottomLeftText}</Typography>
                <Typography>{bottomRightText}</Typography>
            </Box>
            )}
        </Box>
    );
};

export default ProgressIndicator;
